module.exports = __webpack_public_path__ + "img/Logo_ovo_purple.svg.cf8a26d8.png";